/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-04-26 17:12:58
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-06-06 16:12:00
 * @FilePath: \experience-pc\src\store\moudles\userinfo.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getToken, getName, getId, getGroupId,getUserInfo  } from "../../util/cookie";
export default {
    state: {
        token: getToken(),
        name: getName(),
        user_id: getId(),
        group_id: getGroupId(),
        userInfo: getUserInfo(),
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_USER_ID: (state, user_id) => {
            state.user_id = user_id
        },
        SET_GROUP_ID: (state, group_id) => {
            state.group_id = group_id
        },
        SET_USER:(state,userInfo) =>{
            state.userInfo = userInfo
        }
    },
    actions: {

    },
    getters: {
        getToken: state => state.token,
        getUserId: state => state.user_id,
        getAuthName: state => state.name,
        getGroupId : state => state.group_id,
        getUserInfo : state =>  state.userInfo,
    }
}



// WEBPACK FOOTER //
// ./src/store/moudles/userinfo.js